import { render, staticRenderFns } from "./RoleAuthorization.vue?vue&type=template&id=0456ae3b"
import script from "./RoleAuthorization.vue?vue&type=script&lang=js"
export * from "./RoleAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports